import getCustomFieldsByName from "@secureo/common/utils/commerceTools/getCustomFieldsByName"
import { decodeConfigurationsByConfigurationGroup } from "./escapeConfigurationsByConfigurationGroup"

import { LockingSystemComponent, SavedLockingSystem } from "@secureo/common/typings/LockingSystem"
import { ParseLockingSystemTextLineItemAttributes } from "./getInitialReducerStateFromSavedLockingSystem"
import { MinimalConfigurationsByConfigurationGroup } from "./getShoppingListDraftFromLockingSystemReducerState"

export interface LockingSystemComponentDraft
	extends Pick<
		LockingSystemComponent,
		| "uuid"
		| "quantity"
		| "variantId"
		| "sku"
		| "masterVariantSku"
		| "name"
		| "selectedSystem"
		| "selectedOuterLength"
		| "selectedInnerLength"
	> {
	minimalConfigurationsByConfigurationGroup: MinimalConfigurationsByConfigurationGroup
}

const getComponentDraftsByUuidFromTextLineItems = (
	textLineItems: SavedLockingSystem["textLineItems"],
) => {
	const componentDraftsByUuid = textLineItems.reduce(
		(componentDraftsByUuid, textLineItem) => {
			const { name, quantity, custom } = textLineItem

			const {
				uuid,
				sku,
				masterVariantSku,
				variantId,
				selectedInnerLength,
				selectedOuterLength,
				selectedSystem,
				configurationsByConfigurationGroup:
					encodedMinimalConfigurationsByConfigurationGroup,
			} = getCustomFieldsByName(custom) as ParseLockingSystemTextLineItemAttributes

			const minimalConfigurationsByConfigurationGroup =
				decodeConfigurationsByConfigurationGroup(
					encodedMinimalConfigurationsByConfigurationGroup,
				)

			const componentDraft: LockingSystemComponentDraft = {
				uuid,
				quantity,
				variantId,
				sku,
				masterVariantSku,
				name,
				selectedSystem: selectedSystem ? selectedSystem : null,
				selectedOuterLength: selectedOuterLength ? selectedOuterLength : null,
				selectedInnerLength: selectedInnerLength ? selectedInnerLength : null,
				minimalConfigurationsByConfigurationGroup,
			}

			return {
				...componentDraftsByUuid,
				[uuid]: componentDraft,
			}
		},
		{} as {
			[uuid: string]: LockingSystemComponentDraft
		},
	)

	return componentDraftsByUuid
}

export default getComponentDraftsByUuidFromTextLineItems
